// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    font-family: 'Space Grotesk', sans-serif !important;
}

a {
    text-decoration: none;
}

h2 {
    font-size: 1.6rem;
}

.gradient-left-to-right {
    background-image: linear-gradient(to right, #DFDAFF, #ffffff);
}

.gradient-bottom-to-top {
    background-image: linear-gradient(to top, #DFDAFF, #ffffff);
}

.gradient-top-to-bottom {
    background-image: linear-gradient(to bottom, #f0ecfa, #ffffff);
}

.gradient-1 {
    background: linear-gradient(15deg, #BEB0FF, rgba(255, 255, 255, 0.1));
}

.gradient-2 {
    background: linear-gradient(125deg, #BEB0FF, rgba(255, 255, 255, 0.1));
}

.gradient-3 {
    background: linear-gradient(125deg, rgba(190, 176, 255, 0.29), rgba(255, 255, 255, 0.1));
}

.gradient-4 {
    background: linear-gradient(141deg, rgba(95, 88, 128, 0) 30%, rgba(190, 176, 255, 1) 100%);
}

.gradient-5 {
    background: linear-gradient(344deg, rgba(95, 88, 128, 0) 30%, rgba(190, 176, 255, 1) 100%);
}

.gradient-6 {
    background: linear-gradient(125deg, rgba(95, 88, 128, 0) 30%, rgba(176, 187, 255, 1) 100%);
}

.gradient-7 {
    background: linear-gradient(0deg, rgba(95, 88, 128, 0) 30%, rgba(176, 187, 255, 1) 100%);
}

.text-purple {
    color: #BEB0FF;
}

.scrollbar-custom-shadow::after {
    content: '';
    position: absolute;
    right: 0;
    width: 50px;
    height: 100%;
    background: linear-gradient(rgba(255, 255, 255, 0.001), #ce0f0f);
}

.scrollbar-custom::-webkit-scrollbar {
    width: 10px;
}

.scrollbar-custom::-webkit-scrollbar-track {
    background: rgba(190,176,255,0.20);
}

.scrollbar-custom::-webkit-scrollbar-thumb {
    background: #BEB0FF;
    height: 10px;
}

.action-button {
    background-color: #BEB0FF;
    border: none;
    color: black;
    padding: 14px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
}

.action-button:hover {
    background-color: #DFDAFF;
    color: black;
}
.action-button--inverted {
    background-color: #fff;
}
.action-button--inverted:hover {
    background-color: #BEB0FF;
}

.awssld__bullets {
    position: absolute;
    z-index: 100 !important;
    bottom: 22em !important;
    justify-content: left !important;
    width: auto !important;
    padding-left: 7px;
}

.awssld__bullets button {
    background: white !important;
    margin-left: 20px !important;
}

.awssld__bullets .awssld__bullets--active {
    background: #BEB0FF !important;
}

.Mui-selected {
    color: #8364ff !important;
}


@media only screen and (min-width: 1200px) {
    .container {
        width: 80% !important;
    }
}

svg {
    max-width: 100%;
}

.MuiButtonBase-root.MuiBottomNavigationAction-root {
    min-width: 0;
}

.middle-footer .mission-item {
    padding-bottom: 30px;
    text-align: justify;
}

@media only screen and (min-width: 992px) {
    .middle-footer .mission-item {
        padding-right: 30px;
        text-align: left;
    }
    .middle-footer .mission-item--managed {
        padding-left: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,mDAAmD;AACvD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,qEAAqE;AACzE;;AAEA;IACI,sEAAsE;AAC1E;;AAEA;IACI,wFAAwF;AAC5F;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI,wFAAwF;AAC5F;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gEAAgE;AACpE;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,gCAAgC;IAChC,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["body{\n    font-family: 'Space Grotesk', sans-serif !important;\n}\n\na {\n    text-decoration: none;\n}\n\nh2 {\n    font-size: 1.6rem;\n}\n\n.gradient-left-to-right {\n    background-image: linear-gradient(to right, #DFDAFF, #ffffff);\n}\n\n.gradient-bottom-to-top {\n    background-image: linear-gradient(to top, #DFDAFF, #ffffff);\n}\n\n.gradient-top-to-bottom {\n    background-image: linear-gradient(to bottom, #f0ecfa, #ffffff);\n}\n\n.gradient-1 {\n    background: linear-gradient(15deg, #BEB0FF, rgba(255, 255, 255, 0.1));\n}\n\n.gradient-2 {\n    background: linear-gradient(125deg, #BEB0FF, rgba(255, 255, 255, 0.1));\n}\n\n.gradient-3 {\n    background: linear-gradient(125deg, rgba(190, 176, 255, 0.29), rgba(255, 255, 255, 0.1));\n}\n\n.gradient-4 {\n    background: linear-gradient(141deg, rgba(95, 88, 128, 0) 30%, rgba(190, 176, 255, 1) 100%);\n}\n\n.gradient-5 {\n    background: linear-gradient(344deg, rgba(95, 88, 128, 0) 30%, rgba(190, 176, 255, 1) 100%);\n}\n\n.gradient-6 {\n    background: linear-gradient(125deg, rgba(95, 88, 128, 0) 30%, rgba(176, 187, 255, 1) 100%);\n}\n\n.gradient-7 {\n    background: linear-gradient(0deg, rgba(95, 88, 128, 0) 30%, rgba(176, 187, 255, 1) 100%);\n}\n\n.text-purple {\n    color: #BEB0FF;\n}\n\n.scrollbar-custom-shadow::after {\n    content: '';\n    position: absolute;\n    right: 0;\n    width: 50px;\n    height: 100%;\n    background: linear-gradient(rgba(255, 255, 255, 0.001), #ce0f0f);\n}\n\n.scrollbar-custom::-webkit-scrollbar {\n    width: 10px;\n}\n\n.scrollbar-custom::-webkit-scrollbar-track {\n    background: rgba(190,176,255,0.20);\n}\n\n.scrollbar-custom::-webkit-scrollbar-thumb {\n    background: #BEB0FF;\n    height: 10px;\n}\n\n.action-button {\n    background-color: #BEB0FF;\n    border: none;\n    color: black;\n    padding: 14px 20px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.action-button:hover {\n    background-color: #DFDAFF;\n    color: black;\n}\n.action-button--inverted {\n    background-color: #fff;\n}\n.action-button--inverted:hover {\n    background-color: #BEB0FF;\n}\n\n.awssld__bullets {\n    position: absolute;\n    z-index: 100 !important;\n    bottom: 22em !important;\n    justify-content: left !important;\n    width: auto !important;\n    padding-left: 7px;\n}\n\n.awssld__bullets button {\n    background: white !important;\n    margin-left: 20px !important;\n}\n\n.awssld__bullets .awssld__bullets--active {\n    background: #BEB0FF !important;\n}\n\n.Mui-selected {\n    color: #8364ff !important;\n}\n\n\n@media only screen and (min-width: 1200px) {\n    .container {\n        width: 80% !important;\n    }\n}\n\nsvg {\n    max-width: 100%;\n}\n\n.MuiButtonBase-root.MuiBottomNavigationAction-root {\n    min-width: 0;\n}\n\n.middle-footer .mission-item {\n    padding-bottom: 30px;\n    text-align: justify;\n}\n\n@media only screen and (min-width: 992px) {\n    .middle-footer .mission-item {\n        padding-right: 30px;\n        text-align: left;\n    }\n    .middle-footer .mission-item--managed {\n        padding-left: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
